/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import { DefaultLinkWidget, PointModel, LinkWidget } from "@projectstorm/react-diagrams";
import BoldLinkPath from "../LinkHelpers";
import { toastWarning } from "../../../../../utils/methods";

const CustomLinkPlugWidget = (props: any) => {
  const paths = [];
  const color = props.selected ? props.colorSelected : props.color;
  if (!props.extras.sourceCollapsed) {
    paths.push(
      <rect
        key={1}
        x={props.point.getPosition().x - 10}
        y={props.point.getPosition().y - 9}
        fill={color}
        height="12"
        id="svg_21"
        stroke={color}
        strokeWidth="0"
        width="20"
      />
    );
    paths.push(
      <rect
        key={2}
        x={props.point.getPosition().x - 10 + 3}
        y={props.point.getPosition().y - 9 + 3}
        fill={color}
        height="12"
        id="svg_22"
        stroke={color}
        strokeWidth="0"
        transform="matrix(1 0 0 1 0 0)"
        width="14"
      />
    );
    paths.push(
      <rect
        key={3}
        x={props.point.getPosition().x - 10 + 6}
        y={props.point.getPosition().y - 9 + 7}
        fill={color}
        height="11"
        id="svg_23"
        stroke={color}
        strokeWidth="0"
        transform="matrix(1 0 0 1 0 0)"
        width="8"
      />
    );
  }
  if (!props.extras.targetCollapsed) {
    paths.push(
      <rect
        key={4}
        x={props.previousPoint.getPosition().x - 10}
        y={props.previousPoint.getPosition().y - 9}
        fill={color}
        height="12"
        id="svg_21"
        stroke={color}
        strokeWidth="0"
        width="20"
      />
    );
    paths.push(
      <rect
        key={5}
        x={props.previousPoint.getPosition().x - 10 + 3}
        y={props.previousPoint.getPosition().y - 9 + 3}
        fill={color}
        height="12"
        id="svg_22"
        stroke={color}
        strokeWidth="0"
        transform="matrix(1 0 0 1 0 0)"
        width="14"
      />
    );
    paths.push(
      <rect
        key={6}
        x={props.previousPoint.getPosition().x - 10 + 6}
        y={props.previousPoint.getPosition().y - 9 + 7}
        fill={color}
        height="11"
        id="svg_23"
        stroke={color}
        strokeWidth="0"
        transform="matrix(1 0 0 1 0 0)"
        width="8"
      />
    );
  }
  return <g style={{ pointerEvents: "none" }}>{paths}</g>;
};

class CrossConnectLinkWidget extends DefaultLinkWidget {
  generatePlug(point: PointModel, previousPoint: PointModel): JSX.Element {
    return (
      <CustomLinkPlugWidget
        key={point.getID()}
        point={point as any}
        previousPoint={previousPoint as any}
        colorSelected={this.props.link.getOptions().selectedColor}
        color={this.props.link.getOptions().color}
        extras={this.props.link.getOptions().extras}
        selected={this.state.selected}
      />
    );
  }

  render() {
    // ensure id is present for all points on the path
    const points = this.props.link.getPoints();
    const paths = [];
    this.refPaths = [];
    const str = this.props.link.getSVGPath();
    const myElement = this.generateLink(
      str,
      {
        onMouseEnter: () => {
          BoldLinkPath(this.props.link, 8);
          this.props.link.setHovered(true);
          this.props.diagramEngine.repaintCanvas();
        },
        onMouseLeave: () => {
          BoldLinkPath(this.props.link, 2);
          this.props.link.setHovered(false);
          this.props.diagramEngine.repaintCanvas();
        },
        onMouseDown: (e: any) => {
          const sourceId = this.props.link.getSourcePort().getOptions().extras.data.groupId;
          const targetId = this.props.link.getTargetPort().getOptions().extras.data.groupId;
          const sourceCollapsed = this.props.link.getOptions().extras.sourceCollapsed;
          const targetCollapsed = this.props.link.getOptions().extras.targetCollapsed;
          if (this.props.link.getOptions().extras.sourceCollapsed || this.props.link.getOptions().extras.targetCollapsed) {
            let openPorts = JSON.parse(localStorage.getItem("expandedGroupIds") || '[]');
            if (e.buttons === 1) {
                // console.log('outside')
                if (sourceCollapsed) {
                  const sourceGroupIdFunction = `expandGroup${sourceId}`;
                  this.props.diagramEngine.fireEvent({}, sourceGroupIdFunction);
                }
                if (targetCollapsed) {
                  const targetGroupIdFunction = `expandGroup${targetId}`;
                  this.props.diagramEngine.fireEvent({}, targetGroupIdFunction);
                } 
            }
            if (e.buttons === 2) {  
              e.preventDefault();
              if (targetCollapsed && sourceCollapsed) {
                const targetGroupIdFunction = `expandGroup${targetId}`;
                const sourceGroupdIdFunction = `expandGroup${sourceId}`;
                this.props.diagramEngine.fireEvent({}, targetGroupIdFunction);
                this.props.diagramEngine.fireEvent({}, sourceGroupdIdFunction);
              }
              else {
                e.stopPropagation();
                if (!sourceCollapsed) {
                  // console.log('source if', this.props)
                  const sourceGroupIdFunction = `collapseGroup${sourceId}`;
                  this.props.diagramEngine.fireEvent({}, sourceGroupIdFunction);
                }
                if (!targetCollapsed) {
                  // console.log('target if', this.props)
                  const targetGroupIdFunction = `collapseGroup${targetId}`;
                  this.props.diagramEngine.fireEvent({}, targetGroupIdFunction);
                } 
              } 
            }
            /*e.stopPropagation();
            else {
              toastWarning("Groups must be expanded to select a cross connect");
              console.log(this.props)
            }*/
          }
        },
      },
      "0"
    );
    paths.push(myElement);

    if (this.props.link.getTargetPort() !== null) {
      paths.push(this.generatePlug(points[0], points[points.length - 1]));
    }

    return (
      <g className="link-cross-connect" data-default-link-test={this.props.link.getOptions().testName}>
        {paths}
      </g>
    );
  }
}

export default CrossConnectLinkWidget;
